const state = {
  isFrameBusy: false,
  isNavigationSticky: false,
  navElement: {},
  navPosition: 119, // estimated vertical position
}

function bindResizeEvent() {
  window.addEventListener('resize', bindScrollEvent)
}

function bindScrollEvent() {
  const isLargeScreen = window.matchMedia('(min-width: 767px)').matches

  if (isLargeScreen) {
    window.addEventListener('scroll', debounceUpdatePosition)
  } else {
    window.removeEventListener('scroll', debounceUpdatePosition)
  }
}

function debounceUpdatePosition() {
  if (!state.isFrameBusy) {
    window.requestAnimationFrame(updatePosition)
  }
  state.isFrameBusy = true
}

function testBrowserSupportsSticky() {
  const testNode = document.createElement('div')
  const vendorPrefixes = ['', '-webkit-', '-moz-', '-ms-']
  const hasSupport = vendorPrefixes.some((prefix) => {
    try {
      testNode.style.position = prefix + 'sticky'
      /* eslint-disable-next-line no-empty */
    } catch (e) {}
    return testNode.style.position !== ''
  })

  return !!hasSupport
}

function toggleSticky(scrollPosition) {
  const { isNavigationSticky, navElement, navPosition } = state
  const navSibling = navElement.nextElementSibling
  const shouldBeSticky = scrollPosition > navPosition

  // Do nothing if state hasn't changed
  if (isNavigationSticky === shouldBeSticky) return

  if (shouldBeSticky) {
    navElement.classList.add('is-sticky')
    navSibling.style.marginTop = navElement.offsetHeight + 'px'
  } else {
    navElement.classList.remove('is-sticky')
    navSibling.style.marginTop = 0
  }

  state.isNavigationSticky = shouldBeSticky
}

function updatePosition() {
  const { pageYOffset, scrollY } = window

  toggleSticky(scrollY || pageYOffset) // fallback for IE11

  state.isFrameBusy = false
}

export default function () {
  const browserSupportsSticky = testBrowserSupportsSticky()
  const navElement = document.querySelector('.nav-container')

  if (!navElement) {
    console.warn(
      'Navigation element could not be found. Sticky nav component was not initialized.'
    )
    return
  }

  if (browserSupportsSticky) return

  state.navElement = navElement
  state.navPosition = navElement.offsetTop

  bindResizeEvent()
  bindScrollEvent()
}
